import { containsOnlyWhiteSpaces } from './string';

export const sanitizeObject = <T = object>(object: any): T => {
  const clonedObject = { ...object };

  Object.keys(clonedObject).forEach(
    (key: string) =>
      (clonedObject[key] === '' ||
        containsOnlyWhiteSpaces(clonedObject[key])) &&
      delete clonedObject[key],
  );

  return clonedObject;
};
